import { ChromePicker } from "react-color";
import { Theme } from "@mui/material/styles";
import React, { useEffect, useRef, useState } from "react";

import Box from "../Box";
import Typography from "../Typography";

import { Mode } from "../../constants/enums";

import { colorBox, container, popup, typography } from "./styles";

interface IProps {
    mode?: Mode;
    label: string;
    description?: string;
    value: string;
    onChangeValue: (value: string) => void;
}

const ColorPicker: React.FC<IProps> = ({ mode, label, description, value, onChangeValue }) => {
    const ref = useRef<any>(null);
    const [visibled, setVisibled] = useState<boolean>(false);

    const handleOpen = () => {
        if (mode == Mode.View) return;
        setVisibled(true);
    };
    useEffect(() => {
        const checkIfClickedOutside = (e: any) => {
            if (mode === Mode.View) return;
            if (visibled && ref.current && !ref.current.contains(e.target)) {
                setVisibled(false);
            }
        };
        document.addEventListener("mousedown", checkIfClickedOutside);
        return () => {
            // Cleanup the event listener
            document.removeEventListener("mousedown", checkIfClickedOutside);
        };
    }, [visibled, mode]);

    return (
        <Box sx={container}>
            <Typography sx={(theme: Theme) => typography(theme, { fontWeight: 500 })}>{label}</Typography>
            {description && <Typography sx={(theme: Theme) => typography(theme)}>{description}</Typography>}
            <Box ref={ref} onClick={handleOpen} sx={(theme) => colorBox(theme, { disabled: mode === Mode.View })}>
                <Box
                    sx={{
                        width: 100,
                        height: 50,
                        borderRadius: 1,
                        backgroundColor: value,
                    }}
                ></Box>
                <Typography sx={(theme: Theme) => typography(theme, { fontSize: "1.5rem", fontWeight: 500 })}>{value}</Typography>
                {visibled && (
                    <Box sx={popup}>
                        <ChromePicker color={value} onChangeComplete={(color) => onChangeValue(color.hex)} />
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default ColorPicker;
